import { Component, Inject, OnInit } from '@angular/core';
import { IReportTemplate } from '@shared/interfaces';
import { ReportTemplateService } from '@shared/services';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModuleDirective } from '@shared/directives/module.directive';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-template-editor-preview',
    templateUrl: './template-editor-preview.component.html',
    styleUrls: ['./template-editor-preview.component.scss'],
    standalone: false
})
export class TemplateEditorPreviewComponent extends ModuleDirective implements OnInit {
    selectedLanguage = 'en';
    template: IReportTemplate;

    constructor(
        private templateService: ReportTemplateService,
        @Inject(MAT_DIALOG_DATA) public data: IReportTemplate,
        moduleService: ModuleService
    ) {
        super(moduleService);

        this.template = data;
    }

    get languages(): string[] {
        return this.availableLanguages;
    }

    get isEnglish(): boolean {
        return this.selectedLanguage === 'en';
    }

    async ngOnInit() {
        this.template = await this.templateService.getItem(this.data?.id);
    }
}
